let transliterations = null;
import('transliterations').then((t) => {
  transliterations = t;
});

export default val => (transliterations ? transliterations.transliterate(val.replace(/¿/g, '')).replace(/[`´]/g, "'") : val);
